import {PRODUCTION, DEVELOPMENT, LOCAL, STAGING} from "./constants/environment"
import env from "./env"

export const forgotPasswordRedirect = (tenant: string): string => {
  return `${getDomain(tenant)}/welcome/login/reset-password`
}

export const login = (tenant: string): string => {
  return `${getDomain(tenant)}/welcome/login`
}

export const postData = (tenant: string): string => {
  return `${getDomain(tenant)}/api/setValue.html`
}

export const checkEmail = (tenant: string): string => {
  return `${getDomain(tenant)}/welcome/login/check-email`
}

export const getCDNBundleUrl = (): string => {
  return env.PUBLIC_URL
}

export const medicalHome = (subdomain: string): string => {
  return `${getDomain(subdomain)}/medical/my-medical`
}

export const channelPartner = (urlSlug: string): string => {
  return `${getDomain("app")}/channel/${urlSlug}`
}

export const getLocaleUrl = (): string => {
  switch (env.ENVIRONMENT_NAME) {
    case LOCAL:
      return `http://${env.GET_LOCAL}:3000`
    case DEVELOPMENT:
    case STAGING:
    case PRODUCTION:
    default:
      // default prod for safety!
      return "https://cdn.perkbox.com"
  }
}

export const getDomain = (tenant: string): string => {
  const tenantPrefix = getTenantPrefix(tenant)
  switch (env.ENVIRONMENT_NAME) {
    case LOCAL:
      return `http://${tenantPrefix}localhost:3000`
    case DEVELOPMENT:
      return `https://${tenantPrefix}perkbox.dev`
    case STAGING:
      return `https://${tenantPrefix}perkbox.net`
    case PRODUCTION:
    default:
      // default prod for safety!
      return `https://${tenantPrefix}perkbox.com`
  }
}

export const getInternalLinkFromString = (url: string, tenant: string): string | null => {
  const domain = getDomain(tenant)
  if (url.startsWith(domain)) {
    return url.replace(domain, "")
  }

  return null
}

function getTenantPrefix(tenant: string): string {
  return tenant ? `${tenant}.` : ""
}

function adyenLink(pspReference: string): string {
  switch (env.ENVIRONMENT_NAME) {
    case PRODUCTION:
      return `https://ca-live.adyen.com/ca/ca/accounts/showTx.shtml?pspReference=${pspReference}&txType=Payment`
    default:
      return `https://ca-test.adyen.com/ca/ca/accounts/showTx.shtml?pspReference=${pspReference}&txType=Payment`
  }
}

function checkoutLink(pspReference: string): string {
  switch (env.ENVIRONMENT_NAME) {
    case PRODUCTION:
      return `https://dashboard.checkout.com/payments/all-payments/payment/${pspReference}`
    default:
      return `https://dashboard.sandbox.checkout.com/payments/all-payments/payment/${pspReference}`
  }
}

export default {
  forgotPasswordRedirect,
  login,
  postData,
  checkEmail,
  getDomain,
  getLocaleUrl,
  getCDNBundleUrl,
  medicalHome,
  channelPartner,
  adyenLink,
  checkoutLink
}
